import { render, staticRenderFns } from "./Postcodes.vue?vue&type=template&id=0e6a5049&scoped=true&"
import script from "./Postcodes.vue?vue&type=script&lang=js&"
export * from "./Postcodes.vue?vue&type=script&lang=js&"
import style0 from "./Postcodes.vue?vue&type=style&index=0&id=0e6a5049&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6a5049",
  null
  
)

export default component.exports